// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2yP53","header":"ReportDetails_header__2foF_","title":"ReportDetails_title__1CsBX","left":"ReportDetails_left__1-DiU"};